import _ from "lodash";
import React, { Component } from "react";
import { BaseComponent } from "BaseComponent";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import IMap from "./imap";
import BoothEditor from "./bootheditor";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { connect } from "react-redux";
import LocaleStrings from "Languages";
import {
  fetchLinksResource,
  openiMapModal,
  changeMapImage,
  showAddBoothInfo,
  openInteractiveMap,
  uploadNewiMapImage,
  addNewBooth,
  fetchInteractiveMaps,
} from "InteractiveMapAction";
import BoothName from "./boothname";
import { DEFAULT_IMAP_VALUE } from "IMapConstants";
import { Line } from "rc-progress";

import "../modal.scss";

var defaultBoothColor = "#4da1ff";

class InteractiveMap extends BaseComponent {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      showModal: false,
      loading: false,
      toAddNewMap: false,
      mapname: "",
      toEditMapName: false,
      mapImageAvailable: false,
    };

    setTimeout(() => {
      this.props.fetchLinksResource(this.props.session);
    }, 200);

    this.onEditBoothNameCallback = this.onEditBoothNameCallback.bind(this);
    this.onImageAdditionCallback = this.onImageAdditionCallback.bind(this);
  }

  open() {
    this.props.openiMapModal(true);
    this.setState({ toAddNewMap: true });
  }

  close() {
    this.setState({
      toAddNewMap: false,
      toEditMapName: false,
      mapImageAvailable: false,
    });
    this.props.openiMapModal(false);
    //Resetting the selection of map if any
    this.props.openInteractiveMap(DEFAULT_IMAP_VALUE);
    this.props.fetchInteractiveMaps(this.props.session, (callback) => {});
  }

  closeModal() {
    this.close();
  }

  onFormSubmit(values) {
    var data = { ...values };
  }

  onEditBoothNameCallback() {
    this.setState({ toEditMapName: false });
  }

  onImageAdditionCallback() {
    //this.setState({mapImageAvailable:true});
  }

  onImageChangeCallback() {
    if (this.props.uploadFailed) {
      this.props.uploadNewiMapImage(
        this.props.imageToUpload,
        this.props.session
      );
    } else {
      this.setState({ mapImageAvailable: false });
      this.props.changeMapImage();
    }
  }

  onClickEditName() {
    this.setState({ toEditMapName: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedMap && nextProps.selectedMap.mapname.length > 0) {
      if (nextProps.selectedMap.mapname != this.state.mapname) {
        this.setState({ mapname: nextProps.selectedMap.mapname });
      }
    }
    if (nextProps.mapName) {
      if (nextProps.mapName != this.state.mapname) {
        this.setState({ mapname: nextProps.mapName, toAddNewMap: false });
      }
    }

    if (nextProps.selectedMap && nextProps.selectedMap.mapfilepath.length > 0) {
      if (
        nextProps.selectedMap.mapfilepath != this.props.selectedMap.mapfilepath
      ) {
        this.setState({ mapImageAvailable: true });
      }
    }
  }

  componentDidMount() {
    this.setState({ ...this.state, mapImageAvailable: false });
  }

  onExitCallback() {
    if (this.props.uploadInProcess) {
      return false;
    }
  }

  onAddBoothCallback() {
    var boothid = _.uniqueId("booth-");
    var newbooth = {
      locationid: boothid,
      location_x: 300,
      location_y: 200,
      location_width: 50,
      location_height: 50,
      color: defaultBoothColor,
      boothno: "",
    };
    this.props.addNewBooth(newbooth);
    this.props.showAddBoothInfo(true);
  }

  render() {
    var boothEditor;

    var changeMapButtonCss = "button-theme map-button-new button-theme-blue";
    var changeMapTitle = LocaleStrings.content_map_change_map_background;

    if (this.props.uploadFailed) {
      changeMapButtonCss = "button-theme map-button retry-button";
      changeMapTitle = "Retry";
    }

    if (this.props.showBoothEditor) {
      boothEditor = <BoothEditor booth={this.props.booth} />;
    }

    var info = "";

    if (this.props.toggleShowAddBoothInfo) {
      info =
        "Move booth marker and resize to fit in required area. Click on marker to add/edit more details.";
    }

    var footer = "";
    if (!this.state.toAddNewMap && !this.state.toEditMapName) {
      footer = (
        <Modal.Footer>
          <div style={{ width: "100%" }}>
            {this.props.uploadInProcess ? (
              <div className="imap-progress-bar">
                <Line
                  percent={this.props.progress}
                  strokeWidth="2"
                  strokeColor="#4da1ff"
                />
              </div>
            ) : (
              ""
            )}
            {this.state.mapImageAvailable &&
            !this.state.toChangeMap &&
            !this.props.uploadInProcess ? (
              <div className="row">
                <div className="col-md-10">
                  <Button
                    className="button-theme map-button button-theme-blue"
                    style={{ float: "left", marginLeft: "30px" }}
                    onClick={this.onAddBoothCallback.bind(this)}
                  >
                    {" "}
                    + {LocaleStrings.content_map_add_booth}{" "}
                  </Button>
                  {/* changed add-booth-button to button-theme-blue for Add Booth button */}
                  <div
                    className="addBoothInfo upload-error"
                    style={{ marginLeft: "170px" }}
                  >
                    {info}
                  </div>
                </div>
                <div className="col-md-2">
                  <Button
                    className={changeMapButtonCss}
                    onClick={this.onImageChangeCallback.bind(this)}
                  >
                    {changeMapTitle}
                  </Button>
                </div>
              </div>
            ) : (
              ""
            )}
            {/*
              (this.state.mapImageAvailable && !this.state.toChangeMap)?
                <Button className="button-theme map-button button-theme-blue" loading={this.state.loading} type="submit">Save Map</Button>
              :''*/}
          </div>
        </Modal.Footer>
      );
    }

    //if upload in process hide the close button...
    var editbuttonCss = "";
    var closeDisabled = false;
    if (this.props.uploadInProcess) {
      editbuttonCss = "edit-mapname-noicon";
      closeDisabled = true;
    } else {
      editbuttonCss = "edit-mapname-inline";
      closeDisabled = false;
    }

    return (
      <div>
        <div className="map-menuitem" onClick={this.open}>
          Interactive Map
        </div>
        <Modal
          className="modal-container custom-map-modal custom-imap-modal"
          show={this.props.showModal}
          onHide={this.close}
          animation={true}
          keyboard={false}
          onExit={this.onExitCallback.bind(this)}
          size="lg"
        >
          {this.state.toAddNewMap ? (
            ""
          ) : (
            <Modal.Header>
              <Modal.Title className="modal-title-full-width">
                <span style={{ fontWeight: "bold", width: "100%" }}>
                  {this.state.mapname}
                </span>
                {this.state.toAddNewMap ? (
                  ""
                ) : (
                  <button
                    className={editbuttonCss}
                    onClick={this.onClickEditName.bind(this)}
                  >
                    <img src="../../style/images/app-icons/edit_icon.png" />
                  </button>
                )}
                {/* <button
                  type="button"
                  disabled={closeDisabled}
                  className="close btn-sm btn-close "
                  onClick={() => this.closeModal()}
                >
                <span aria-hidden="true">&times;</span>65
                </button> */}
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                  disabled={closeDisabled}
                  // style={{textAlign:'end'}}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Title>
            </Modal.Header>
          )}
          {/*../../../../../style/images/imap.png*/}
          {this.state.toAddNewMap ? (
            <BoothName
              callback={() => this.close()}
              history={this.props.history}
            />
          ) : (
            <Modal.Body>
              <div>
                <IMap imageCallback={this.onImageAdditionCallback} />
                <CSSTransitionGroup
                  transitionName="booth-editor-transition"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={300}
                >
                  {boothEditor}
                </CSSTransitionGroup>
              </div>
            </Modal.Body>
          )}
          {this.state.toEditMapName ? (
            <BoothName
              toEdit={true}
              callback={this.onEditBoothNameCallback}
              history={this.props.history}
            />
          ) : (
            ""
          )}
          {footer}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    session: state.session,
    showBoothEditor: state.showBoothEditor,
    booth: state.addEditBooth.booth,
    selectedMap: state.selectediMap,
    showModal: state.openiMapModal.payload,
    mapName: state.addMapName.payload,
    progress: state.imapUploadProgress,
    uploadInProcess:
      state.imapUploadProgress &&
      state.imapUploadProgress >= 0 &&
      state.imapUploadProgress < 100,
    uploadFailed: state.imapImageUploadFailed,
    imageToUpload: state.imapImageToUpload,
    toggleShowAddBoothInfo: state.showAddBoothInfo,
  };
}

export default connect(mapStateToProps, {
  fetchLinksResource,
  openiMapModal,
  showAddBoothInfo,
  changeMapImage,
  fetchInteractiveMaps,
  openInteractiveMap,
  addNewBooth,
  uploadNewiMapImage,
})(InteractiveMap);
